module.exports = __webpack_public_path__ + "img/facilityA.ecdc218e.svg";